import { getApiHeaders } from "./authHeaders";

/**
 * fetch() wrapper that attaches Firebase Bearer headers when signed in.
 * Prefer this over inline `headers: await getApiHeaders()` so callers need not be async.
 *
 * @param {string} url
 * @param {RequestInit} [options]
 * @returns {Promise<Response>}
 */
export async function apiFetch(url, options = {}) {
  const { headers: extraHeaders, ...rest } = options || {};
  const headers = await getApiHeaders(extraHeaders || {});
  return fetch(url, { ...rest, headers });
}
